module.exports = __webpack_public_path__ + "static/media/login_bg.51a89406.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/login_bg.png
// module id = 1451
// module chunks = 0